import React, { useState, useEffect } from 'react';
import { IoMdEye } from 'react-icons/io';
import { MdDelete } from "react-icons/md";
import { Button, Pagination } from '@mui/material';
import { json, useNavigate } from 'react-router-dom';
import { useMyContext } from '../../../context/MyContext';
import Sidebar from '../../../component/b2b/sideBar/b2bSideBar';
import NavBar from '../../../component/b2b/navBar/b2bNavBar';
import PaginationItem from '@mui/material/PaginationItem';
import '../../../css/custom-scrollbar.css';
import { LuWarehouse } from "react-icons/lu";
import axios from 'axios';
import Swal from 'sweetalert2';
import { Base_Url, deletewarehouse, b2bWarehouseList } from '../../../config/config';
import B2bViewWarehouse from '../../../component/b2b/models/viewWarehouseModel';

const AllWarehouses = () => {
  const [totalOrders, setTotalOrders] = useState(0);
  const { isDarkMode } = useMyContext();
  const [isPopupOpen,setIsPopupOpen] = useState(false);
  const { isToggleSidebar } = useMyContext();
  const [warehouses,setWarehouses] = useState([]);
  const [currentPage,setCurrentPage] = useState(1);
  const [selectedWarehouse,setSelectedWarehouse] = useState(null);
   const [loadingWarehouseId,setloadingWarehouseId] = useState(null);
  const itemsPerPage = 8;
  const navigate = useNavigate();

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  useEffect(() => {
    fetchWarehouses();
  }, [page, limit]);

  const fetchWarehouses = async () => {
    const token = localStorage.getItem('token');
    const cusid = localStorage.getItem('cus_id');
    try {
      const pageNumber = Number(page) || 1;
      const limitNumber = Number(limit) || 10;
      const urlWarehouse = `${Base_Url}${b2bWarehouseList}?page=${pageNumber}&limit=${limitNumber}`
      const response = await fetch(urlWarehouse, {
        method: 'GET',
        headers: {
          'token': token,
          'cus_id': cusid,
          'Content-Type': 'application/json'
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      if (result.status === "SUCCESS" && Array.isArray(result.data)) {
        setWarehouses(result.data);
        setTotalOrders(result.pagination.totalItems || 0);
      } else {
        console.error('Unexpected response format:', result);
      }
    } catch (error) {
      console.error('Error fetching warehouse data:', error);
    }
  };

  const handlePaginationChange = (event, value) => {
    setPage(value);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPage(1);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = warehouses.slice(indexOfFirstItem, indexOfLastItem);

  const handleViewClick = (warehouse) => {
    setSelectedWarehouse(warehouse);
    setIsPopupOpen(true);
  };

  const handleClose = () => {
    setIsPopupOpen(false);
  };

  const handleNavigation = () => {
    navigate('/dashboard');
  };

  const handleDelete = async (id) => {
  setloadingWarehouseId(id);

  Swal.fire({
    title: 'Are you sure?',
    text: "You won't be able to revert this deletion!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, delete it!'
  }).then(async (result) => {
    if (result.isConfirmed) {
      const urldelete = Base_Url + deletewarehouse; 
      try {
        const token = localStorage.getItem('token');
        const cusid = localStorage.getItem('cus_id');
        const data = { warehouseId: id };

        const response = await axios.post(urldelete, data, {
          headers: {
            token,
            cus_id: cusid,
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          },
        });

        if (response.data.status === "SUCCESS") {
          setWarehouses((prevWarehouses) =>
            prevWarehouses.filter((warehouse) => warehouse.id !== id)
          );
          setTotalOrders((prev) => prev - 1);

          Swal.fire(
            'Deleted!',
            response.data.message || 'Warehouse has been deleted successfully.',
            'success'
          );
        } else {
          Swal.fire(
            'Error!',
            'Unexpected response format: ' + response.data.message,
            'error'
          );
        }
      } catch (error) {
        Swal.fire(
          'Error!',
          'Error deleting warehouse: ' + error.message,
          'error'
        );
      } finally {
        setloadingWarehouseId(null);
      }
    } else {
      setloadingWarehouseId(null);
    }
  });
};


  return (
    <>
      <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
        <div className="z-10">
          <NavBar />
        </div>

        <div className="flex flex-1 overflow-hidden">
          {isToggleSidebar && (
            <div className={`fixed z-20 h-full w-64 md:relative duration-300 bg-gray-200 dark:bg-darkmodeColor dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20`}
              style={
                window.innerWidth < 768
                  ? { top: "113px", height: "calc(100vh - 115px)", overflowY: 'auto' }
                  : {}
              }>
              <Sidebar />
            </div>
          )}

          <div className={`bg-gray-100 overflow-x-hidden ml-4  mb-6 w-full rounded-custom overflow-y-auto dark:shadow-custom-dark p-4 ${isDarkMode ? 'dark:bg-darkmodeColor text-white' : ''}`}>

            <button onClick={handleNavigation}
              className="text-xl w-full sm:text-2xl font-bold mb-4 sm:mb-6 bg-customPurple hover:bg-purple-700 text-white font-sans px-2 sm:px-4 py-2 sm:py-1 rounded h-[40px]  sm:w-full flex items-center justify-center">
              <LuWarehouse className="mr-2" size={24} />
              All WareHouses
            </button>

            <div className="overflow-x-auto">
              <table className="min-w-full table-auto overflow-y-auto">
                <thead className='bg-gradient-to-r from-[#0540a6] to-[#0650c4] text-white text-[10px] dark:bg-darkmodeColor dark:text-white'>
                  <tr>
                    <th className='p-2 text-left font-semibold'>ID</th>
                    <th className='p-2 text-left font-semibold'>Name</th>
                    <th className='p-2 text-left font-semibold'>Contact Person</th>
                    <th className='p-2 text-left font-semibold'>Phone</th>
                    <th className='p-2 text-left font-semibold'>City</th>
                    <th className='p-2 text-left font-semibold'>State</th>
                    <th className='p-2 text-left font-semibold'>Country</th>
                    <th className='p-2 text-left font-semibold'>Action</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100 dark:divide-gray-700 dark:bg-darkmodeColor">
                  {warehouses.map((warehouse, index) => (
                    <tr
                      key={warehouse.id}
                      className={`hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-150 ${index % 2 === 0
                        ? 'bg-white dark:bg-darkmodeColor'
                        : 'bg-gray-50/30 dark:bg-[rgba(1,14,78,0.8)]'
                        }`}
                    >
                      <td className='p-2 text-xs text-blue-600 dark:text-blue-400 cursor-pointer hover:text-blue-800 dark:hover:text-blue-300 font-medium transition-colors'>
                        {warehouse.warehouse_id}
                      </td>
                      <td className='p-2 text-xs text-gray-700 dark:text-gray-300 font-medium'>{warehouse.name}</td>
                      <td className='p-2 text-xs text-gray-700 dark:text-gray-300 font-medium'>{warehouse.contact_person}</td>
                      {/* <td className='p-2 text-xs text-gray-700 dark:text-gray-300 font-medium'>{warehouse.email}</td> */}
                      <td className='p-2 text-xs text-gray-600 dark:text-gray-400 font-mono'>{warehouse.phone_number}</td>
                      <td className='p-2 text-xs text-gray-700 dark:text-gray-300 font-medium'>{warehouse.city}</td>
                      <td className='p-2 text-xs text-gray-700 dark:text-gray-300 font-medium'>{warehouse.state}</td>
                      <td className='p-2 text-xs text-gray-700 dark:text-gray-300 font-medium'>{warehouse.country}</td>
                      <td className='p-2'>
                        <div className='flex items-center gap-1'>
                          <Button
                            onClick={() => handleViewClick(warehouse)}
                            variant="contained"
                            color="primary"
                            size="small"
                            className="min-w-0 p-1 rounded-md shadow-sm hover:shadow-md transition-shadow"
                            style={{
                              backgroundColor: '#3b82f6',
                              '&:hover': { backgroundColor: '#2563eb' }
                            }}
                          >
                            <IoMdEye className="text-xs" />
                          </Button>

                          <Button
                            onClick={() => handleDelete(warehouse.id)}
                            variant="contained"
                            color="error"
                            size="small"
                            disabled={loadingWarehouseId === warehouse.id}
                            className="min-w-0 p-1 rounded-md shadow-sm hover:shadow-md transition-shadow"
                            style={{
                              backgroundColor: loadingWarehouseId === warehouse.id ? '#f8d7da' : '#ef4444',
                              color: loadingWarehouseId === warehouse.id ? '#721c24' : 'white',
                              '&:hover': { backgroundColor: loadingWarehouseId === warehouse.id ? '#f8d7da' : '#dc2626' }
                            }}
                          >
                            {loadingWarehouseId === warehouse.id ? (
                              <span className="animate-spin">⏳</span>
                            ) : (
                              <MdDelete className="text-xs" />
                            )}
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="mt-4 flex flex-col sm:flex-row justify-between items-center space-y-2 sm:space-y-0">
              <span className="text-sm text-gray-700 font-bold dark:text-gray-300">{`Total Warehouse: ${totalOrders}`}</span>
              <select
                id="limit"
                value={limit}
                onChange={handleLimitChange}
                className="border rounded p-1 sm:ml-[480px] text-sm bg-white dark:bg-darkmodeColor dark:text-gray-200"
              >
                <option value={10}>10</option>
                <option value={15}>15</option>
                {/* <option value={50}>50</option> */}
                <option value={totalOrders}>All</option>
              </select>
              <Pagination
                count={Math.ceil(totalOrders / limit)}
                page={page}
                onChange={handlePaginationChange}
                variant="outlined"
                shape="rounded"
                className="pagination"
                size="small"
                renderItem={(item) => (
                  <PaginationItem
                    {...item}
                    className={`mx-1 rounded-md ${item.selected ? 'bg-customPurple text-white' : 'text-gray-700 dark:text-gray-300'} hover:bg-purple-700 hover:text-white`}
                  />
                )}
              />
            </div>
          </div>
        </div>
        <B2bViewWarehouse isopen={isPopupOpen} onClose={handleClose} warehouse={selectedWarehouse} />
      </div>
    </>
  );
};

export default AllWarehouses;
